import * as React from "react";
import { Card, CardHeader, CardContent, CardFooter, List, ListItem, Icon, BlockTitle, Button } from "framework7-react";
import "./eventInfoCard.css";
import { withTranslation } from "react-i18next";

import { formateTimestamp } from "../../../../functions";

class EventInfoCard extends React.Component {
  state = { show_desc: false };

  show_more = () => {
    let desc = this.props.data.desc.replace(/(<([^>]+)>)/gi, " ");
    if (desc.length > 500) {
      return true;
    }
    return false;
  };

  fixHtml = (html) => {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.innerHTML;
  };

  render_teaser_text = (html) => {
    let new_string = html.substring(0, 500);
    return this.fixHtml(new_string);
  };

  format_html = (html) => {
    return html.replace(/<a href/g, '<a class="external" target="_blank" href');
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <Card className="event-info-card">
          {this.props.data.img && (
            <CardHeader className="no-border" valign="bottom" style={{ padding: 0 }}>
              <img style={{ width: "100%", height: "100%", objectFit: "cover", borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }} src={this.props.data.img} alt={this.props.data.img_alt_text} />
            </CardHeader>
          )}
          <CardContent>
            <p className="title">{this.props.data.title}</p>
            <p className="sub-title">{this.props.data.organizer}</p>
          </CardContent>
          {(this.props.data.periode.start > 0 || this.props.data.adr || this.props.data.options.max_participants > 0) && (
            <CardContent style={{ borderTop: "1px solid #E1E1E1", marginTop: "-20px" }}>
              <List mediaList>
                {this.props.data.periode.start > 0 && this.props.data.periode.end > 0 && (
                  <ListItem
                    title={
                      <>
                        {t("event.start")} <b>{formateTimestamp(this.props.data.periode.start)}</b>
                        <br />
                        {t("event.end")} <b>{formateTimestamp(this.props.data.periode.end)}</b>
                      </>
                    }
                  >
                    <Icon slot="media" material="today"></Icon>
                  </ListItem>
                )}
                {this.props.data.periode.start > 0 && this.props.data.periode.end === 0 && (
                  <ListItem
                    title={
                      <>
                        {t("event.start")} <b>{formateTimestamp(this.props.data.periode.start)}</b>
                      </>
                    }
                  >
                    <Icon slot="media" material="today"></Icon>
                  </ListItem>
                )}
                {this.props.data.adr &&
                  (this.props.data.adr_full ? (
                    <ListItem title={this.props.data.adr} subtitle={this.props.data.adr_full.secondary} text={this.props.data.adr_full.desc}>
                      <Icon slot="media" f7="placemark"></Icon>
                    </ListItem>
                  ) : (
                    <ListItem title={this.props.data.adr}>
                      <Icon slot="media" f7="placemark"></Icon>
                    </ListItem>
                  ))}
                {this.props.data.options.max_participants > 0 &&
                  (this.props.data.options.show_participants_nr ? (
                    <ListItem title={t("event.available_for_registration", { qty: this.props.data.available_tickets })} subtitle={t("event.total_for_registration", { total: this.props.data.options.max_participants })}>
                      <Icon slot="media" material="group"></Icon>
                    </ListItem>
                  ) : (
                    <ListItem title={t("event.total_available_for_registration", { total: this.props.data.options.max_participants })}>
                      <Icon slot="media" material="group"></Icon>
                    </ListItem>
                  ))}
              </List>
            </CardContent>
          )}
        </Card>
        {!this.props.noDesc &&
          this.props.data.desc &&
          this.props.data.desc.length > 10 &&
          (this.state.show_desc ? (
            <>
              <BlockTitle>
                {t("info_about")} <b>{this.props.data.title}</b>
              </BlockTitle>
              <Card>
                <CardContent>
                  <div dangerouslySetInnerHTML={{ __html: this.format_html(this.props.data.desc) }}></div>
                </CardContent>
              </Card>
            </>
          ) : (
            <>
              <BlockTitle>
                {t("info_about")} <b>{this.props.data.title}</b>
              </BlockTitle>
              {this.show_more() ? (
                <Card>
                  <CardContent>
                    <div className={"event-desc-card"} dangerouslySetInnerHTML={{ __html: this.render_teaser_text(this.format_html(this.props.data.desc)) }} />
                  </CardContent>
                  <div style={{ marginTop: "-54px" }}>
                    <CardContent style={{ background: "linear-gradient(rgba(255,255,255,0), rgb(255,255,255))", height: "38px" }} />
                  </div>
                  <CardFooter>
                    <span></span>
                    <Button onClick={() => this.setState({ show_desc: true })}>{t("view_more")}</Button>
                  </CardFooter>
                </Card>
              ) : (
                <Card>
                  <CardContent>
                    <div dangerouslySetInnerHTML={{ __html: this.format_html(this.props.data.desc) }}></div>
                  </CardContent>
                </Card>
              )}
            </>
          ))}
      </>
    );
  }
}

export default withTranslation()(EventInfoCard);
